import axios from 'axios'

const axiosInstance = axios.create({
    baseURL: "/api",
    //baseURL: "http://localhost:8443/api",
	//baseURL: "https://tomcat9tst1:8505/api",
    headers: {
        'contentType': 'application/json',
        'Accept': 'application/json',
        "Cache-Control": "no-cache",
        "access-Control-Allow-Origin": "*"
    }
}) 

export default axiosInstance

